'use client'

import { useEffect } from 'react'

import { useGlobalStore } from '@/shared/store/provider'
import type { SystemStore } from '@/shared/store/slices/systemSlice'

export type SystemDataCollectorProps = {
  slugs: SystemStore['system']['_slugs']
  pageCustomerType: SystemStore['system']['_pageCustomerType']
}

export const SystemDataInitiator = ({ pageCustomerType, slugs }: SystemDataCollectorProps) => {
  const { _setSlugs, _setPageCustomerType } = useGlobalStore((state) => state.system)

  useEffect(() => {
    // This effect is providing information about all available dynamic slug pathname translations to support language change
    _setSlugs(slugs)
    _setPageCustomerType(pageCustomerType)
  }, [])

  return null
}
